import React from 'react';
import propTypes from 'prop-types';
import ReactModal from 'react-modal';
import { getRoomShortTitle } from '../../common';

const converMinusToZero = val => (val < 0 ? 0 : val);
const AccomodationAvailability = props => (
    <ReactModal
        isOpen={props.visible}
        onRequestClose={() => props.toggleVisibility(!props.visible)}
        className="availability-info-modal"
        ariaHideApp={false}
    >
        <h2><i className="fa fa-hotel" /> Accomodation Availability</h2>
        <table className="table table-striped">
            <thead>
                <tr>
                    <td className="title">
                        Pelagian
                    </td>
                    <td>Total Room</td>
                    <td>Room Allocated</td>
                    <td>Availability</td>
                </tr>
            </thead>
            <tbody>
                {Object.keys(props.data).map(key => ({
                    name: key,
                    ...props.data[key],
                })).filter(a => (a.location.toLowerCase() === 'pelagian'))
                    .map(o => (
                        <tr key={o.name}>
                            <td>{getRoomShortTitle(o.roomType)}</td>
                            <td>{o.totalRoom}</td>
                            <td>{o.totalUsed}</td>
                            <td>{converMinusToZero(o.totalRoom - o.totalUsed)}</td>
                        </tr>
                    ))
                }
            </tbody>
        </table>
        <table className="table table-striped">
            <thead>
                <tr>
                    <td className="title">
                        Resort
                    </td>
                    <td>Total Room</td>
                    <td>Room Allocated</td>
                    <td>Availability</td>
                </tr>
            </thead>
            <tbody>
                {Object.keys(props.data).map(key => ({
                    name: key,
                    ...props.data[key],
                })).filter(a => (a.location.toLowerCase() === 'wakatobi'))
                    .map(o => (
                        <tr key={o.name}>
                            <td>{getRoomShortTitle(o.roomType)}</td>
                            <td>{o.totalRoom}</td>
                            <td>{o.totalUsed}</td>
                            <td>{converMinusToZero(o.totalRoom - o.totalUsed)}</td>
                        </tr>
                    ))
                }
            </tbody>
        </table>
        <button className="btn btn-block btn-alternate" onClick={() => props.toggleVisibility(!props.visible)} style={{ backgroundColor: '#' }}>
            <i className="fa fa-times" />
            &nbsp;&nbsp;Close
        </button>
    </ReactModal>
);


AccomodationAvailability.propTypes = {
    data: propTypes.array.isRequired,
    visible: propTypes.bool,
    toggleVisibility: propTypes.func.isRequired,
};

AccomodationAvailability.defaultProps = {
    visible: false,
};

export default AccomodationAvailability;
